var path = '/static/assets/khapps/fms_app/partials/includes/fms_navbar_views.html';
var html = "<map-table-nav-buttons ng-if=\"!sub_app_page_id\"></map-table-nav-buttons>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;